import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarImpuestosEliminarComponent {
  data
  onClose
  procesando = false

  constructor (FacturacionConfiguracionConceptosConceptoImpuestos) {
    this.FacturacionConfiguracionConceptosConceptoImpuestos = FacturacionConfiguracionConceptosConceptoImpuestos
  }

  aceptar () {
    if (this.procesando) return
    this.procesando = true

    this.FacturacionConfiguracionConceptosConceptoImpuestos.delete(this.data.id_concepto, this.data.indice)
      .then(() => (this.cerrar()))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.onClose({$event: {details: {eliminado: false}}})
  }

  cerrar () {
    this.onClose({$event: {details: {eliminado: true}}})
  }
}

module.component('facturacionConfiguracionConceptosEditarImpuestosEliminar', {
  controller: FacturacionConfiguracionConceptosEditarImpuestosEliminarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/impuestos/eliminar/component.js